import React from 'react';
import { isSameDay } from 'date-fns';
import moment from 'moment';
import { dateDefaultRanges } from '../../utils/suitableDate';

const LAST_WEEK = '7 derniers jours';
const LAST_FOUR_WEEK = '4 dernières semaines';
const DEEPLINK_CREATION_DATE = 'Depuis la création';
interface StaticRangeHandler {
  range: () => { startDate: Date; endDate: Date };
  isSelected(range: { startDate: Date; endDate: Date }): boolean;
}
export const parseDate = (startDate: Date, endDate: Date, deepLinkCreationDate?: Date) => {
  if (
    moment(startDate).isSame(moment(dateDefaultRanges.startOfWeek), 'day') &&
    moment(endDate).isSame(moment(dateDefaultRanges.endOfWeek), 'day')
  ) {
    return 'Cette semaine';
  }
  if (
    moment(startDate).isSame(moment(dateDefaultRanges.lastSevenDays), 'day') &&
    moment(endDate).isSame(moment(dateDefaultRanges.today), 'day')
  ) {
    return LAST_WEEK;
  }
  if (
    moment(startDate).isSame(moment(dateDefaultRanges.startOfMonth), 'day') &&
    moment(endDate).isSame(moment(dateDefaultRanges.endOfMonth), 'day')
  ) {
    return 'Ce mois-ci';
  }
  if (
    moment(startDate).isSame(moment(dateDefaultRanges.lastFourWeeks), 'day') &&
    moment(endDate).isSame(moment(dateDefaultRanges.today), 'day')
  ) {
    return LAST_FOUR_WEEK;
  }
  if (
    deepLinkCreationDate && moment(startDate).isSame(moment(deepLinkCreationDate), 'day')
  ) {
    return DEEPLINK_CREATION_DATE;
  }
  return `${moment(startDate).locale('fr').format('ll')} - ${moment(endDate).locale('fr').format('ll')}`;
};


const staticRangeHandler: StaticRangeHandler = {
  range: () => ({ startDate: new Date(), endDate: new Date() }),
  isSelected(range: { startDate: Date; endDate: Date }) {
    const definedRange = this.range();
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    );
  }
};


export function createStaticRanges(ranges: Array<{ label: string; range: () => { startDate: Date; endDate: Date } }>): StaticRangeHandler[] {
  return ranges.map(range => ({ ...staticRangeHandler, ...range }));
}


export const defaultStaticRanges = (deepLinkCreationDate?: Date) => {
  const ranges = [
    {
      label: 'Cette semaine',
      range: () => ({
        startDate: dateDefaultRanges.startOfWeek,
        endDate: dateDefaultRanges.endOfWeek
      })
    },
    {
      label: LAST_WEEK,
      range: () => ({
        startDate: dateDefaultRanges.lastSevenDays,
        endDate: dateDefaultRanges.today
      })
    },
    {
      label: 'Ce mois-ci',
      range: () => ({
        startDate: dateDefaultRanges.startOfMonth,
        endDate: dateDefaultRanges.endOfMonth
      })
    },
    {
      label: LAST_FOUR_WEEK,
      range: () => ({
        startDate: dateDefaultRanges.lastFourWeeks,
        endDate: dateDefaultRanges.today
      })
    }
  ];
  if (deepLinkCreationDate) {
    ranges.push({
      label: DEEPLINK_CREATION_DATE,
      range: () => ({
        startDate: deepLinkCreationDate,
        endDate: new Date(),
      }),
    });
  }

  return createStaticRanges(ranges);
};

export const defaultInputRanges = [];


export const onClick = (
  event: React.MouseEvent<HTMLButtonElement>,
  setAnchorEl: React.Dispatch<React.SetStateAction<null | HTMLElement>>,
  setOpen: React.Dispatch<React.SetStateAction<boolean>>,
  open: boolean
) => {
  setAnchorEl(event.currentTarget);
  setOpen(!open);
};

export const onClose = (
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setOpen(false);
};
const isStaticRangeSelected = (selectedRange, staticRanges) => {
  return staticRanges.some((range) => {
    const definedRange = range.range();
    return (
      moment(selectedRange.startDate).isSame(definedRange.startDate, 'day') &&
      moment(selectedRange.endDate).isSame(definedRange.endDate, 'day')
    );
  });
};
export const handleSelectDate = (
  ranges: { selection: { startDate: Date; endDate: Date } },
  onSelectDate: (dateRange: { startDate: Date; endDate: Date }) => void,
  setOpen: React.Dispatch<React.SetStateAction<boolean>>,
  setSelectedDateRange: React.Dispatch<React.SetStateAction<any>>,
  isSelectingRange: boolean,
  setIsSelectingRange: React.Dispatch<React.SetStateAction<boolean>>,
  staticRanges
) => {
  const selectedRange = ranges.selection;
  selectedRange.endDate = moment(ranges.selection.endDate)
    .endOf('day')
    .toDate();
  setSelectedDateRange(selectedRange);
  if (isStaticRangeSelected(selectedRange, staticRanges) || !moment(selectedRange?.startDate).isSame(moment(selectedRange?.endDate), 'days')) {
    onSelectDate(selectedRange);
    setOpen(false);
    setIsSelectingRange(false);
    return;
  }
  if (!isSelectingRange) {
    setIsSelectingRange(true);
  } else {
    onSelectDate(selectedRange);
    setOpen(false);
    setIsSelectingRange(false);
  }
};



